import { Injectable } from '@angular/core';
import { PagedTableResponse } from '../../models/common/paged-table.model';
import {
  ParkingWebStampHistoryRow,
  ParkingWebStampHistoryRowDto,
} from '../../models/parking/parking-web-stamp-history.model';

@Injectable({ providedIn: 'root' })
export class MapperParkingWebStampHistoryService {
  private readonly captureBase = 'https://pss-upload.cloud/Parkingcaptures/';

  mapRow(dto: unknown): ParkingWebStampHistoryRow {
    const r = dto as ParkingWebStampHistoryRowDto & Record<string, unknown>;
    const pictureStamp = (r.pictureStamp ?? r.PictureStamp ?? null) as string | null;
    return {
      id: Number(r.id ?? r.Id ?? 0),
      rateName: String(r.rateName ?? r.RateName ?? ''),
      cardCode: String(r.cardCode ?? r.CardCode ?? ''),
      license: String(r.license ?? r.License ?? ''),
      vehicleTypeName: String(r.vehicleTypeName ?? r.VehicleTypeName ?? ''),
      gateId: String(r.gateId ?? r.GateId ?? ''),
      stampTime: (r.stampTime ?? r.StampTime ?? null) as string | null,
      remark: String(r.remark ?? r.Remark ?? ''),
      userId: (r.userId ?? r.UserId ?? null) as number | null,
      userDisplayName: String(r.userDisplayName ?? r.UserDisplayName ?? ''),
      pictureStamp: pictureStamp?.trim() || null,
      pictureUrl: this.resolvePictureUrl(pictureStamp),
    };
  }

  mapTable(res: unknown): PagedTableResponse<ParkingWebStampHistoryRow> {
    const raw = res as Record<string, unknown>;
    const list = (raw['data'] ?? raw['Data'] ?? []) as unknown[];
    const pageSize = Number(raw['pageSize'] ?? raw['PageSize'] ?? 20);
    const total = Number(raw['total'] ?? raw['Total'] ?? 0);
    const page = Number(raw['page'] ?? raw['Page'] ?? 1);
    return {
      data: list.map((item) => this.mapRow(item)),
      total,
      page,
      pageSize,
      totalPages: Number(raw['totalPages'] ?? raw['TotalPages'] ?? Math.ceil(total / Math.max(pageSize, 1))),
    };
  }

  /** relative path → capture base; full URL as-is; legacy HTML &lt;img src&gt; → extract */
  resolvePictureUrl(raw: string | null | undefined): string | null {
    const value = (raw ?? '').trim();
    if (!value) return null;

    const fromHtml = value.match(/src\s*=\s*["']([^"']+)["']/i)?.[1]?.trim();
    const path = fromHtml || value;
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    return this.captureBase + path.replace(/^\//, '');
  }
}
